module.exports = __webpack_public_path__ + "static/media/GateRunnerConcept.e5b8c978.jpg";